import { IconBrandMark } from '../../icons';

import './styles/BrandLogo.css';

export default function BrandLogo({ isInverted = false }) {
    return (
        <span className={`brand-logo ${isInverted ? 'brand-logo--inverted' : ''}`.trim()}>
            <IconBrandMark />
            <span className="brand-logo__wordmark">
                <span className="brand-logo__word brand-logo__word--first">total</span>
                <span className="brand-logo__word brand-logo__word--second">medios</span>
            </span>
        </span>
    );
}
